import React from 'react';

const QuickAnswers = () => {
    return (
        <svg width={19.1} height={21} viewBox="0 0 19.1 21">
            <path
                d="M10.5 1L1 12.4h8.55L8.6 20l9.5-11.4H9.55z"
                fill="none"
                stroke="#8f99dc"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
        </svg>
    );
};

export default QuickAnswers;
